<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tit1"><a id="page_ii"></a><a id="page_iii"></a>Pug – Churchill’s</h1>
<p class="tit2">Chief of Staff</p>
<p class="stit1">The Life of General</p>
<p class="stit1">Hastings Ismay <span class="small">KG GCB CH DSO PC</span>,</p>
<p class="stit1">1887–1965</p>
<p class="author">Andrew Sangster</p>
<div class="img_container">
<img alt="Images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?5bc52d61